<template>
  <div class="side">
    <router-link to='/outline'>
      <div class="menu" @click="clickSiryo">
        <p style="margin-top:0;">
          <!--&#9654;&nbsp;-->データベース概要</p>
      </div>
    </router-link>
    <div class="menu" @click="clickDatabase">
        <p style="margin-top:0;">データベース</p>
    </div>


    <div class="side-scroll">
      <div class="sitemap">
        <ul>
          <li class="toplevel" v-for="(item, index) in kaiso1Data" :key="index">

            <a href="javascript:void(0);" @click="clickMenuTree(item)">▶</a>
            <!--<a href="javascript:void(0);" @click="clickMenu(item)" v-bind:class="{sel:isOpen(item)}">{{item.Title}}</a>-->
            <a href="javascript:void(0);" @click="clickMenu(item)" @dblclick="dblclickMenu(item)" v-bind:class="{sel:isOpenSel(item)}">{{item.Title}}</a>

              <ul  v-show="isOpen(item)" style="margin-left:5px;">

                <li v-for="(item2, index2) in kaiso2Data(item)" :key="index2">

                  <a href="javascript:void(0);" @click="clickDataTree(item2)">▶</a>
                  <!--<a href="javascript:void(0);" @click="clickData(item2)" v-bind:class="{sel:isOpen2(item2)}">{{item2.Title}}</a>-->
                  <a href="javascript:void(0);" @click="clickData(item2)" @dblclick="dblclickData(item2)" v-bind:class="{sel:isOpen2Sel(item2)}">{{item2.Title}}</a>

                  <ul class="" v-show="isOpen2(item2)" style="margin-left:5px;">
                    <li v-for="(item3, index3) in kaiso3Data(item2)" :key="index3">
                      {{item3.Title}}
                    </li>
                  </ul>

                </li>
              </ul>
          </li>

        </ul>
      </div>
    </div>

    <router-link to='/guide'>
      <div class="menu" @click="clickRiyou">
        <p style="margin-top:0;">
          <!--&#9654;&nbsp;-->利用案内</p>
      </div>
    </router-link>

    <a href="index.html" style="display: none;">
      <div class="menu">
        <p style="margin-top:0;">&#9654;&nbsp;資料について</p>
      </div>
    </a>

    <div class="link" style="margin:24px 12px; 0">
      <a href="http://riis.skr.u-ryukyu.ac.jp/"><img src="../assets/img/link2.png" width="297" height="87" alt="リンク２"></a>
    </div>
    <div class="link" style="margin:24px 12px; 0">
      <a href="http://www.u-ryukyu.ac.jp/"><img src="../assets/img/link1.png" width="297" height="85" alt="リンク１"></a>
    </div>

  </div>
</template>
<style lang="scss">
.js-accordion {
  &--target {
    transition: height 0.4s ease-in-out;
  }
  // (略)
  &-enter-active {
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: js-accordion--anime__opend;
  }
  &-leave-active {
    animation-duration: 0.3;
    animation-fill-mode: both;
    animation-name: js-accordion--anime__closed;
  }
}

@keyframes js-accordion--anime__opend {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes js-accordion--anime__closed {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
<style lang="css">
/*
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to   {
  opacity: 0;
}
*/

.dispno {
  display: none;
}
.sitemap ul {
  padding-left: 20px;
  list-style: none;
 }
.sitemap ul li ul {
  margin-top: 0.5em;
  margin-bottom: 0.75em;
  margin-left: 48px;
}

.sitemap ul li ul li {
  margin-bottom: 0.25em;
  position: relative;
}

.sitemap ul li ul li::before {
  content: '';
  position: absolute;
  top: -0.5em;
  left: -16px;
  width: 10px;
  height: calc(100% + 0.75em);
  border-left: 1px solid #3972b2;
}

.sitemap ul li ul li:last-child::before {
  height: calc(1em + 0.25em);
}

.sitemap ul li ul li::after {
  content: '';
  position: absolute;
  top: 0.75em;
  left: -16px;
  width: 10px;
  border-bottom: 1px solid #3972b2;
}

.sel{
  font-weight: bold;
}
.toplevel{
  margin-bottom: 10px;
}
</style>
<script>
import axios from 'axios'
export default {
  name: 'Treeside',
  computed: {
    kaiso1Data() {
      return this.$store.getters.kaiso1tbl
    },
    kaiso2Data() {
      return function(item) {
        var self = this
        return self.$store.getters.kaiso2tbl.filter(function(row, index) {
          if (row.Code1 === this.Code1 && row.Code2 === this.Code2) return true
        }, item)
      }
    },
    kaiso3Data() {
      return function(item) {
        var self = this
        return self.$store.getters.kaiso3tbl.filter(function(row, index) {
          if (
            row.Code1 === this.Code1 &&
            row.Code2 === this.Code2 &&
            row.Code3 === this.Code3
          )
            return true
        }, item)
      }
    },
/*     isOpen() {
      return function(item) {
        if (this.$store.getters.openMenuId === `${item.Code1}/${item.Code2}`)
          return true
      }
    }, */
/*     isOpen2() {
      return function(item) {
        if (
          this.$store.getters.openMenuId2 ===
          `${item.Code1}/${item.Code2}/${item.Code3}`
        )
          return true
      }
    }, */
    isOpen() {
      return function(item) {
        var target = this.$store.getters.openMenuId.find(menuid => {
            return menuid === `${item.Code1}/${item.Code2}`
        }) 
        if (target === `${item.Code1}/${item.Code2}`) {
          return true
        }
      }
    },
    isOpen2() {
      return function(item) {
         var target = this.$store.getters.openMenuId2.find(menuid2 => {
            return menuid2 === `${item.Code1}/${item.Code2}/${item.Code3}`
        }) 
        if (target === `${item.Code1}/${item.Code2}/${item.Code3}`) {
          return true
        }
      }
    },

    isOpenSel() {
      return function(item) {
        if (this.$store.getters.selMenuId === `${item.Code1}/${item.Code2}`)
          return true
      }
    },
    isOpen2Sel() {
      return function(item) {
        if (this.$store.getters.selMenuId2 === `${item.Code1}/${item.Code2}/${item.Code3}`)
          return true

      }
    },

  },

  created: function() {
    var self = this
    self.init()
  },
  data() {
    return {}
  },
  methods: {
    init() {
      this.getAllKaisoData(function(res) {})
    },
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      el.style.height = '0'
    },
    clickSiryo(){
        this.$store.dispatch('upSelMenuId', '')
        this.$store.dispatch('upSelMenuId2', '')
        this.$store.dispatch('delAllOpenMenuId', '')       
        this.$store.dispatch('delAllOpenMenuId2', '')       
        this.$router.push(`/outline`)
    },
    clickDatabase(){
        this.$store.dispatch('upSelMenuId', '')
        this.$store.dispatch('upSelMenuId2', '')
        this.$store.dispatch('delAllOpenMenuId', '')       
        this.$store.dispatch('delAllOpenMenuId2', '')       
        this.$router.push(`/database`)
    },
    clickRiyou(){
        this.$store.dispatch('upSelMenuId', '')
        this.$store.dispatch('upSelMenuId2', '')
        this.$store.dispatch('delAllOpenMenuId', '')       
        this.$store.dispatch('delAllOpenMenuId2', '')       
        this.$router.push(`/outline`)
    },
    clickMenu(item) {
      //表示ページ階層判断用
      this.$store.dispatch('upSelMenuId2', '')
      this.$store.dispatch('upSelMenuId', `${item.Code1}/${item.Code2}`)

      this.$router.push(`/database/${item.Code1}/${item.Code2}`)
    },
    //ダブルクリック
    dblclickMenu(item) {
       var self = this
      var target= self.$store.getters.openMenuId.find(menuid => {
        return menuid === `${item.Code1}/${item.Code2}`
      }) 

      self.$store.dispatch('dlOpenMenuId', `${item.Code1}/${item.Code2}`)
      if (target === `${item.Code1}/${item.Code2}`) {
      } else {
        self.$store.dispatch('upOpenMenuId', `${item.Code1}/${item.Code2}`)
      }

      /*ADD-190408 表示ページ階層判断用 */
      this.$store.dispatch('upSelMenuId2', '')
      this.$store.dispatch('upSelMenuId', `${item.Code1}/${item.Code2}`)

      this.$router.push(`/database/${item.Code1}/${item.Code2}`)
    },
    clickMenuTree(item) {
      var self = this
      var target= self.$store.getters.openMenuId.find(menuid => {
        return menuid === `${item.Code1}/${item.Code2}`
      }) 

      self.$store.dispatch('dlOpenMenuId', `${item.Code1}/${item.Code2}`)
      if (target === `${item.Code1}/${item.Code2}`) {
      } else {
        self.$store.dispatch('upOpenMenuId', `${item.Code1}/${item.Code2}`)
      }
    },

    clickData(item) {
      this.$router.push(`/database/${item.Code1}/${item.Code2}/${item.Code3}`)
    },
    //ダブルクリック
    dblclickData(item) {
      var self = this
      var target= self.$store.getters.openMenuId2.find(menuid2 => {
        return menuid2 === `${item.Code1}/${item.Code2}/${item.Code3}`
      }) 

      if (target === `${item.Code1}/${item.Code2}/${item.Code3}`) {
        self.$store.dispatch('dlOpenMenuId2', `${item.Code1}/${item.Code2}/${item.Code3}`)
      } else {
        self.$store.dispatch('upOpenMenuId2', `${item.Code1}/${item.Code2}/${item.Code3}`)
      }
        this.$router.push(`/database/${item.Code1}/${item.Code2}/${item.Code3}`)
    },
    clickDataTree(item) {
      var self = this
      var target= self.$store.getters.openMenuId2.find(menuid2 => {
        return menuid2 === `${item.Code1}/${item.Code2}/${item.Code3}`
      }) 

      if (target === `${item.Code1}/${item.Code2}/${item.Code3}`) {
        self.$store.dispatch('dlOpenMenuId2', `${item.Code1}/${item.Code2}/${item.Code3}`)
      } else {
        self.$store.dispatch('upOpenMenuId2', `${item.Code1}/${item.Code2}/${item.Code3}`)
      }
    },

  }
}
</script>
